
class ShoppableVideos extends HTMLElement {
  constructor () {
    super()

    this.querySelectorAll('button.video-play-button').forEach(btn => {
      btn.addEventListener('click', () => {
        const video = btn.querySelector('video')
        this.playVideo(video)
      })
    })

    this.pauseVideosOnScroll()
  }

  playVideo (video) {
    this.querySelectorAll('video').forEach(elem => {
      if (elem.dataset.index !== video.dataset.index) {
        elem.closest('.shoppable-videos-card').setAttribute('data-playing', 'false')
        elem.pause()
      }
    })

    const card = video.closest('.shoppable-videos-card')

    if (card.dataset.playing === 'true') {
      card.setAttribute('data-playing', 'false')
      video.pause()
      video.blur()
    } else {
      card.setAttribute('data-playing', 'true')
      video.muted = false
      video.play()
      video.focus()
    }
  }

  pauseAllVideos () {
    this.querySelectorAll('video').forEach(video => {
      if (video.closest('.shoppable-videos-card').dataset.playing === 'true') {
        video.closest('.shoppable-videos-card').setAttribute('data-playing', 'false')
        video.pause()
      }
    })
  }

  pauseVideosOnScroll () {
    this.querySelector('.carousel-track').addEventListener('scroll', () => {
      this.pauseAllVideos()
    })
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          this.pauseAllVideos()
        }
      })
    }, { threshold: 0.25 })

    observer.observe(this)
  }
}
customElements.define('shoppable-videos', ShoppableVideos)